<template>
    <div class="record-choose-list">
        <no-data
            v-if="noRecordData"
            v-bind:noteText="'记录空空如也~'">
        </no-data>
        <!-- 标题部分 -->
        <div v-if="recordList.length > 0" class="layout-rl-title dsp-flex">
            <div class="layout-rlt-letter">{{recordCurOrderIndex == 3 ? '最近浏览' : recordCurFirstL}}</div>
            <div class="layout-rlt-note">
                <div class="dsp-flex" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                    <span v-for="string in stringArr">{{string}}</span>
                </div>
            </div>
        </div>
        <!-- 列表部分 -->
        <div class="record-choose-main-list">
            <virtual-list id="RecordChooseList" ref="vsl" class="overflow-y-scroll scroll-touch"
                :data-key="'id'"
                :data-sources="recordList"
                :data-component="itemComponent"
                :estimate-size="20"
                :item-class="'com-record-item-w88'" />
        </div>
    </div>
</template>

<script>
import ChooseRecordChooseItem from '../../components/ChooseRecordChooseItem.vue'
import NoData from '../../components/common/NoData.vue'
export default {
    name: 'RecordChooseList',
    components: { NoData },
    computed: {
        chooseFromPage() {
            return this.$store.state.chooserecord.chooseFromPage;
        },
        noRecordData() {
            return this.$store.state.record.noRecordData;
        },
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        recordList() {
            return this.$store.state.chooserecord.chooseRecordGender > 0 ? 
            this.$store.state.record.recordListData.filter(el => { return el.sexNum+1 == this.$store.state.chooserecord.chooseRecordGender; }) 
            : this.$store.state.record.recordListData;
        },
        recordCurOrderIndex() {
            return this.$store.state.record.recordCurOrderIndex;
        },
        scrollToIndex() {
            return this.$store.state.recordletter.scrollToIndex;
        },
        recordCurFirstL() {
            return this.$store.state.recordletter.recordCurFirstL;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    data() {
        return {
            itemComponent: ChooseRecordChooseItem,
            stringArr: ['年', '月', '日', '时'],
        }
    },
    mounted() {
        this.$bus.on('updateScrollByLetter', this.clickLetterItem)
        this.$bus.on('updateScrollToTop', this.scrollToTop)
        setTimeout(() => {
            this.initDom();
        }, 300);
    },
    destroyed() {
        this.$bus.off('updateScrollByLetter', this.clickLetterItem)
        this.$bus.off('updateScrollToTop', this.scrollToTop)
    },
    methods: {
        initDom() {
            var barDom = document.getElementsByClassName('record-choose-bar')[0],
                titleDom = document.getElementsByClassName('layout-rl-title')[0],
                listDom = document.getElementById('RecordChooseList');
            var height = innerHeight;
                height = barDom ? height - barDom.clientHeight : height;
                height = titleDom ? height - titleDom.clientHeight : height;
            if(listDom) {
                listDom.style.height = height + 'px';
            }
        },
        clickLetterItem(index) {
            if(this.$refs.vsl) {
                this.$refs.vsl.scrollToIndex(index);
            }
        },
        scrollToTop() {
            if(this.$refs.vsl) {
                this.$refs.vsl.scrollToIndex(0);
            }
        }

    }
}
</script>